/* Paintly AI Studio presence. What each piece is and why: snippets/paintly-ai-presence.liquid.
   Approved 12 Oct 2026, Protos/AI Studio Placements Studio, Rounds 1 to 4.

   One rule runs through all of it: a shopper without designs sees the site exactly as it was.
   This file never makes a browser id. It reads the one assets/paintly-owner.js keeps (after the
   shopper has made a design) and asks the image worker for that browser's designs, the same
   POST /api/designs the AI Studio and the account page make. The answer is kept for ten minutes
   in sessionStorage, so moving between pages costs nothing. */
(function () {
  'use strict';
  var C = window.PAINTLY_AIP;
  if (!C || !C.api || window.__pkaip) return;
  window.__pkaip = true;

  var doc = document;
  var STUDIO = C.studio || '/pages/ai-studio';
  var MAKE = C.make || '/collections/ai-custom-kits';
  var KEY = 'ply_aip_v2', TTL = 10 * 60 * 1000;
  var SHAPE = /^[a-z0-9]{16,64}$/;

  var SPARK = '<svg class="pkaip-spk" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l1.6 4.6L18 9.2l-4.4 1.6L12 15.4l-1.6-4.6L6 9.2l4.4-1.6z"/><path d="M18.5 14.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z"/></svg>';
  var SPARK_LINE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 3.5l1.9 5.1L18 10.5l-5.1 1.9L11 17.5l-1.9-5.1L4 10.5l5.1-1.9z"/><path d="M18.5 15l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var UP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
  var DOWN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M6 13l6 6 6-6"/></svg>';
  var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function el(html) { var d = doc.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  function safeUrl(u) { u = String(u || ''); if (/^\/\//.test(u)) u = 'https:' + u; return /^(https:\/\/|\/(?!\/))/.test(u) ? u : ''; }
  function img(u, cls) { return '<img' + (cls ? ' class="' + cls + '"' : '') + ' src="' + esc(u) + '" alt="" loading="lazy" decoding="async">'; }
  function designs(n) { return n === 1 ? '1 design' : n + ' designs'; }
  function phone() { return window.innerWidth < 641; }

  /* ── whose designs: read, never make ── */
  function owner() {
    var v = '';
    try { v = localStorage.getItem('ply_owner_id') || ''; } catch (e) {}
    if (SHAPE.test(v)) return v;
    var m = doc.cookie.match(/(?:^|;\s*)ply_oid=([^;]+)/);
    try { v = m ? decodeURIComponent(m[1]) : ''; } catch (e) { v = ''; }
    return SHAPE.test(v) ? v : '';
  }
  function credit() { try { var v = localStorage.getItem('plyCreditCode') || ''; return /^PAINT-[A-Z0-9]{8}$/.test(v) ? v : ''; } catch (e) { return ''; } }
  function readCache(o, c) {
    try { var d = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (d && d.o === o && d.c === c && Date.now() - d.t < TTL && Array.isArray(d.u)) return d; } catch (e) {}
    return null;
  }
  function writeCache(d) { try { sessionStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} }

  function snapshot(o, c, rows) {
    rows = rows.filter(function (x) { return x && safeUrl(x.u); }).slice();
    rows.sort(function (a, b) { return (Date.parse(b.t || '') || 0) - (Date.parse(a.t || '') || 0); });
    return { o: o, c: c, t: Date.now(), n: rows.length, u: rows.slice(0, 12).map(function (x) { return safeUrl(x.u); }) };
  }
  function load(o, c, fresh) {
    if (!fresh) { var cached = readCache(o, c); if (cached) return Promise.resolve(cached); }
    var done = false;
    return new Promise(function (res, rej) {
      var t = setTimeout(function () { if (!done) { done = true; rej(new Error('timeout')); } }, 12000);
      fetch(C.api + '/api/designs', {
        method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ownerId: o, creditCode: c })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('http ' + r.status)); })
        .then(function (d) {
          if (done) return;
          done = true; clearTimeout(t);
          if (!d || !Array.isArray(d.designs)) { rej(new Error('invalid designs')); return; }
          res(snapshot(o, c, d.designs));
        }, function (e) { if (!done) { done = true; clearTimeout(t); rej(e); } });
    });
  }

  var S = { n: 0, u: [] };

  /* ── header, computers only: sparkle and count next to the account icon ── */
  function header() {
    var old = doc.querySelector('.pkaip-hic');
    if (!S.n) { if (old) old.remove(); return; }
    var label = designs(S.n) + ' saved';
    var html = '<a class="pkaip pkaip-hic header__icon link" href="' + STUDIO + '" aria-label="AI Studio, ' + label + '">' +
      '<i class="pkaip-hsv">' + SPARK_LINE + '</i><i class="pkaip-badge">' + (S.n > 99 ? '99+' : S.n) + '</i>' +
      '<span class="pkaip-tip" aria-hidden="true"><b>AI Studio</b>&nbsp;·&nbsp;' + label + '</span></a>';
    if (old) { old.replaceWith(el(html)); return; }
    var acc = doc.querySelector('a.header__icon--account');
    if (acc && acc.parentNode) acc.parentNode.insertBefore(el(html), acc);
  }

  /* ── menu on computers: a "Your designs" card in each AI Studio panel ── */
  function mega() {
    [].forEach.call(doc.querySelectorAll('.sub.s-ai .aigrid'), function (g) {
      var old = g.querySelector('.pkaip-mc');
      if (old) old.remove();
      g.classList.toggle('pkaip-4', !!S.n);
      if (!S.n) return;
      var u = S.u.slice(0, 4);
      g.appendChild(el('<a class="pkaip pkaip-mc" href="' + STUDIO + '"><span class="pkaip-g pkaip-c' + u.length + '">' + u.map(function (x) { return img(x); }).join('') +
        '</span><span class="pkaip-cap"><b>Your designs</b><small>' + SPARK + S.n + ' saved in your AI Studio</small></span></a>'));
    });
  }

  /* ── phone menu: the Design with AI block grows into one AI block ── */
  function phoneMenu() {
    [].forEach.call(doc.querySelectorAll('.aibar .ai-in'), function (inn) {
      if (!inn.hasAttribute('data-pkaip-was')) {
        var ic = inn.querySelector('.ab-ic');
        inn.setAttribute('data-pkaip-was', '');
        inn.setAttribute('data-pkaip-ic', ic ? ic.getAttribute('src') : '');
        inn.__pkaipWas = inn.innerHTML;
      }
      if (!S.n) {
        if (inn.classList.contains('pkaip-in')) { inn.innerHTML = inn.__pkaipWas; inn.classList.remove('pkaip-in'); }
        return;
      }
      var tiles = S.u.slice(0, 4).map(function (x, i) {
        return '<a href="' + STUDIO + '" aria-label="Open your AI Studio">' + img(x) + (i === 3 && S.n > 4 ? '<span class="pkaip-more">+' + (S.n - 3) + '</span>' : '') + '</a>';
      }).join('');
      var icon = inn.getAttribute('data-pkaip-ic');
      inn.classList.add('pkaip-in');
      inn.innerHTML = '<div class="pkaip pkaip-shelf">' +
        '<a class="pkaip-row" href="' + MAKE + '">' + (icon ? '<img class="pkaip-ic" src="' + esc(icon) + '" alt="">' : '') +
        '<span class="pkaip-tt"><b>Design with AI <span class="pkaip-nw">NEW</span></b><small>Make a new design in seconds</small></span>' +
        '<span class="pkaip-go" aria-hidden="true">' + CHEV + '</span></a>' +
        '<span class="pkaip-hr"></span>' +
        '<a class="pkaip-lb" href="' + STUDIO + '"><b>Your AI Studio</b><span>' + S.n + ' saved' + CHEV + '</span></a>' +
        '<div class="pkaip-tiles">' + tiles + '</div></div>';
    });
  }

  /* ── wishlist page: their AI designs, under the saved kits ── */
  function wishlist() {
    var inner = doc.querySelector('.pw-page .pw-page__inner');
    if (!inner) return;
    var slot = inner.querySelector('.pw-ai-slot');
    if (!slot) { slot = doc.createElement('div'); slot.className = 'pw-ai-slot'; }
    inner.appendChild(slot);
    var old = inner.querySelector('.pkaip-wl');
    if (old) old.remove();
    if (!S.n) return;
    var cards = S.u.slice(0, 12).map(function (x) {
      return '<a class="pkaip-wlc" href="' + STUDIO + '">' + img(x) + '<span>' + SPARK + 'AI design</span></a>';
    }).join('');
    slot.replaceChildren(el('<section class="pkaip pkaip-wl" aria-labelledby="pkaip-wl-h"><div class="pkaip-wlh"><span class="pkaip-dia" aria-hidden="true"></span>' +
      '<h2 id="pkaip-wl-h">Your AI designs</h2><span class="pkaip-cn">' + S.n + '</span><i aria-hidden="true"></i>' +
      '<a class="pkaip-btn" href="' + STUDIO + '"><span>Open AI Studio</span>' + CHEV + '</a></div>' +   /* in the heading line, styled like Choose options (Amjhed, 23 Oct 2026) */
      '<p>Kept in your AI Studio, ready to order as a kit.</p><div class="pkaip-wlrow">' + cards + '</div></section>'));
  }

  /* ── the design tools ── */
  var T = null;
  function tool() {
    var prompt = doc.getElementById('aigen-prompt'), results = doc.getElementById('aigen-results');
    if (!prompt || !results) return;
    var root = doc.getElementById('paintly-aigen') || prompt.closest('.shopify-section') || doc.body;
    T = {
      root: root, prompt: prompt, results: results,
      deep: /[?&](design|remix)=/.test(location.search),
      typing: false, formSeen: false, key: '', seenSet: ''
    };

    /* the line under the idea box, for everyone */
    var box = prompt.closest('.ag2-ta') || prompt.parentElement;
    if (box && box.parentNode && !root.querySelector('.pkaip-note')) {
      var second = C.signedIn ? '' : '<span class="pkaip-n2">Saved on this device. <a href="' + esc(C.login || '/account/login') + '">Sign in</a> and they follow you everywhere.</span>';
      /* under the box's own "Like this:" examples when the page has them: they belong right under the box (Amjhed) */
      var after = box.nextElementSibling && box.nextElementSibling.classList.contains('ag2-tip') ? box.nextElementSibling : box;
      after.parentNode.insertBefore(el('<p class="pkaip pkaip-note"><span class="pkaip-ns">' + SPARK_LINE + '</span><span>Every design you make is saved in your <a href="' + STUDIO + '">AI Studio</a>.' + second + '</span></p>'), after.nextSibling);
    }
    /* the quiet line under new designs: no link, so it never pulls anyone away from choosing */
    var act = results.querySelector('.ag2-resact');
    if (act && !results.querySelector('.pkaip-q')) act.parentNode.insertBefore(el('<p class="pkaip pkaip-q" hidden>' + SPARK_LINE + 'Both saved to your AI Studio</p>'), act.nextSibling);

    /* the bar */
    T.bar = el('<div class="pkaip pkaip-bar" role="region" aria-label="AI Studio" hidden><div class="pkaip-wr"></div></div>');
    doc.body.appendChild(T.bar);
    T.bar.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pkaip-go]');
      if (!a) return;
      var where = a.getAttribute('data-pkaip-go');
      if (where === 'studio') return;                       /* a plain link */
      e.preventDefault();
      var to = where === 'designs' ? doc.getElementById('aigen-grid') || T.results : doc.getElementById('paintly-ai-form');
      if (!to) return;
      var y = to.getBoundingClientRect().top + window.pageYOffset - (where === 'designs' ? 120 : 80);
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    });

    /* typing on a phone: the bar steps aside so the keyboard and the box have the room */
    doc.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('textarea, input, select')) { T.typing = true; schedule(); } });
    doc.addEventListener('focusout', function () { T.typing = false; schedule(); });

    /* the options are on screen: the page's own Add to cart is the only one there */
    var form = doc.getElementById('paintly-ai-form');
    if (form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { T.formSeen = es[0].isIntersecting; schedule(); }, { rootMargin: '0px 0px -25% 0px' }).observe(form);
    }
    new MutationObserver(schedule).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class', 'disabled', 'src'] });
    window.addEventListener('resize', schedule);
    schedule();
  }

  function shown(e) { return !!e && e.style.display !== 'none' && e.offsetParent !== null; }
  function optsLine() {
    var names = String(C.opts || '').split('|').filter(Boolean).map(function (o) {
      o = o.toLowerCase();
      return o === 'canvas' ? 'colors' : o;      /* the Canvas option is where the color count is chosen */
    });
    if (!names.length) return 'Choose your options.';
    if (names.length === 1) return 'Choose your ' + names[0] + '.';
    return 'Choose ' + names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] + '.';
  }
  function ring(label, short, icon, go, href, cls) {
    return '<a class="pkaip-ag ' + (cls || '') + '" href="' + (href || '#') + '" data-pkaip-go="' + go + '"' + (label ? '' : ' aria-label="' + esc(short) + '"') + '><span class="pkaip-in">' +
      (icon === 'spark' ? SPARK : '') + (label ? '<span class="pkaip-lg">' + label + '</span><span class="pkaip-sh">' + short + '</span>' : '') + (icon && icon !== 'spark' ? icon : '') + '</span></a>';
  }

  var queued = false;
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; update(); }); } }

  function update() {
    if (!T) return;
    var pw = doc.getElementById('aigen-paywall');
    var paywall = shown(pw);
    var gen = doc.getElementById('aigen-generate');
    var loading = !!(gen && gen.disabled);
    var loadedImgs = [].slice.call(T.results.querySelectorAll('.aigen-card.is-loaded img'));
    var loaded = shown(T.results) && loadedImgs.length > 0;
    var sel = doc.getElementById('aigen-selected');
    var picked = shown(sel);

    var q = T.results.querySelector('.pkaip-q');
    if (q) q.hidden = !loaded;

    /* new designs on screen: they are saved now, so the count everywhere else is out of date */
    var set = loadedImgs.map(function (i) { return i.getAttribute('src') || ''; }).join('|');
    if (loaded && set && set !== T.seenSet && !T.results.classList.contains('is-fromstudio')) {
      T.seenSet = set;
      setTimeout(function () { refresh(true); }, 1500);
    }

    if (paywall) paywallUp(pw);

    var state = paywall || loading ? '' : picked ? 'picked' : loaded ? 'choose' : (S.n && !T.deep ? 'arrive' : '');
    var html = '';
    if (state === 'arrive') {
      html = '<span class="pkaip-th">' + S.u.slice(0, 3).map(function (x) { return img(x); }).join('') + '</span>' +
        '<span class="pkaip-tx"><b>' + (S.n === 1 ? 'Your design is saved' : 'Your ' + S.n + ' designs are saved') + '</b><small>Pick up where you left off.</small></span>' +
        ring('Open AI Studio', 'Open', 'spark', 'studio', STUDIO);
    } else if (state === 'choose') {
      html = '<span class="pkaip-two">' + loadedImgs.slice(0, 2).map(function (i) { return img(i.getAttribute('src')); }).join('') + '</span>' +
        '<span class="pkaip-tx"><b>Tap the design you love</b><small>Then build your kit right here.</small></span>' +
        ring('', 'Back to your designs', UP, 'designs', '#aigen-grid', 'pkaip-rnd');
    } else if (state === 'picked') {
      var si = doc.getElementById('aigen-selected-img');
      var src = si && safeUrl(si.getAttribute('src'));
      html = (src ? img(src, 'pkaip-pic') : '') +
        '<span class="pkaip-tx"><b>Next, build your kit</b><small>' + esc(optsLine()) + '</small></span>' +
        ring('Choose options', 'Options', DOWN, 'options', '#paintly-ai-form');   /* the same ring button as the bar's other two (Amjhed, 12 Oct) */
    }
    var key = state + '|' + (state === 'arrive' ? S.n + S.u.slice(0, 3).join() : state === 'choose' ? set : state === 'picked' ? (doc.getElementById('aigen-selected-img') || {}).src : '');
    if (key !== T.key) { T.key = key; T.bar.firstChild.innerHTML = html; }

    var visible = !!state && !doc.querySelector('#ag2-gmask.open') && !(T.typing && phone()) && !(state === 'picked' && T.formSeen);
    T.bar.hidden = !visible;
    doc.documentElement.classList.toggle('pkaip-has-bar', visible && phone());
  }

  /* ── design tool: the welcome back strip under the guide button, for people with designs ── */
  function welcome() {
    if (!T) return;
    var hero = doc.querySelector('.ag2-hero');
    if (!hero) return;
    var old = hero.querySelector('.pkaip-wb');
    if (!S.n || T.deep) { if (old) old.remove(); return; }
    if (old && old.getAttribute('data-n') === String(S.n)) return;
    var s = el('<a class="pkaip pkaip-wb" href="' + STUDIO + '"><span class="pkaip-th">' + S.u.slice(0, 3).map(function (x) { return img(x); }).join('') + '</span>' +
      '<span class="pkaip-tx"><b>Welcome back! ' + (S.n === 1 ? 'Your design is saved.' : 'Your ' + S.n + ' designs are saved.') + '</b><small>See them in your AI Studio, or make more below.</small></span>' +
      '<span class="pkaip-go" aria-hidden="true">' + ARROW + '</span></a>');
    s.setAttribute('data-n', String(S.n));
    if (old) old.replaceWith(s); else hero.appendChild(s);
  }

  /* ── out of tries: their saved designs first, then every pack, each plainly a button to buy ── */
  function paywallUp(pw) {
    var title = doc.getElementById('pw-title');
    var strip = pw.querySelector('.pkaip-wb');
    if (S.n) {
      var html = '<a class="pkaip pkaip-wb" href="' + STUDIO + '"><span class="pkaip-th">' + S.u.slice(0, 3).map(function (x) { return img(x); }).join('') + '</span>' +
        '<span class="pkaip-tx"><b><span class="pkaip-lg">' + (S.n === 1 ? 'Your design is saved' : 'Your ' + S.n + ' designs are saved') + '</span><span class="pkaip-sh">' + designs(S.n) + ' saved</span></b>' +
        '<small><span class="pkaip-lg">Turn one into a kit, or see them all in your AI Studio.</span><span class="pkaip-sh">See them in your AI Studio.</span></small></span>' +
        '<span class="pkaip-go" aria-hidden="true">' + ARROW + '</span></a>';
      if (!strip || strip.getAttribute('data-n') !== String(S.n)) {
        var s = el(html); s.setAttribute('data-n', String(S.n));
        if (strip) strip.replaceWith(s); else if (title) title.parentNode.insertBefore(s, title);
      }
    }
    if (pw.hasAttribute('data-pkaip')) return;
    var buy = doc.getElementById('pw-buy');
    var packs = (C.packs || []).filter(function (p) { return p && p.v && p.n; });
    if (!buy || !packs.length || !C.sf) return;
    pw.setAttribute('data-pkaip', '');
    /* Round 8, C4 "Cream cards" (Amjhed): the pack, its name and a lime Buy button, on site cream */
    var rows = packs.map(function (p, i) {
      return '<button type="button" class="pkaip-op" data-pkaip-pack="' + i + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="48" height="48">' : '') +
        '<b class="pkaip-nm">' + p.n + ' more tries</b>' +
        '<span class="pkaip-buy">Buy ' + esc(String(p.p || '').replace(/\s+[A-Z]{3}$/, '')) + '</span></button>';
    }).join('');
    var block = el('<div class="pkaip pkaip-pk"><p class="pkaip-k">Buy more tries and keep creating today. Every try makes two designs, and tries never expire.</p>' + rows +
      '<p class="pkaip-nt">Checkout opens in a new tab. Your cart and designs stay as they are.</p></div>');
    buy.parentNode.insertBefore(block, buy);
    buy.style.display = 'none';
    block.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pkaip-pack]');
      if (b) checkout(b, packs[+b.getAttribute('data-pkaip-pack')]);
    });
    var s1 = pw.querySelector('.agpw-srow .agpw-stx');
    if (s1) s1.textContent = 'Pick a pack above and pay in the new tab.';
  }

  /* the same separate cart the design tool's own pack button makes, so the shopper's cart is untouched */
  function checkout(btn, p) {
    if (!p || btn.disabled) return;
    var w = null;
    try { w = window.open('about:blank', '_blank'); } catch (e) {}      /* inside the tap, or the browser blocks it */
    var lbl = btn.querySelector('.pkaip-buy'), was = lbl ? lbl.textContent : '';
    btn.disabled = true; if (lbl) lbl.textContent = 'Opening…';   /* it has to fit in the Buy pill */
    var body = JSON.stringify({
      query: 'mutation($l:[CartLineInput!]!){ cartCreate(input:{ lines:$l }){ cart{ checkoutUrl } } }',
      variables: { l: [{ merchandiseId: 'gid://shopify/ProductVariant/' + p.v, quantity: 1 }] }
    });
    fetch('/api/2024-10/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': C.sf }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var u = d && d.data && d.data.cartCreate && d.data.cartCreate.cart && d.data.cartCreate.cart.checkoutUrl;
        if (!u) throw new Error('no checkout');
        if (w && !w.closed) w.location = u; else window.location.href = u;
      })
      .catch(function () {
        if (w && !w.closed) w.close();
        window.location.href = '/products/' + encodeURIComponent(p.h);
      })
      .then(function () { btn.disabled = false; if (lbl) lbl.textContent = was; });
  }

  /* ── put it together ── */
  function paint() {
    header(); mega(); phoneMenu(); wishlist(); welcome();
    if (T) { T.key = ''; schedule(); var pw = doc.getElementById('aigen-paywall'); if (shown(pw)) paywallUp(pw); }
  }
  var presenceSuspended = false;
  var revision = 0, identity = '', pending = '', lastLoaded = 0;
  function identityKey() { return owner() + '|' + credit(); }
  function accept(d) {
    S.n = d.n; S.u = d.u; lastLoaded = d.t;
    writeCache(d); paint();
  }
  function refresh(fresh) {
    if (presenceSuspended) return;
    var o = owner(), c = credit(), key = o + '|' + c;
    var ticket = ++revision;
    if (key !== identity) {
      identity = key; lastLoaded = 0; S.n = 0; S.u = []; paint();
    }
    if (!o) { pending = ''; return; }
    pending = key;
    load(o, c, fresh).then(function (d) {
      if (ticket === revision) { pending = ''; if (key === identityKey()) accept(d); }
    }, function () { if (ticket === revision) pending = ''; });
  }
  function syncIdentity() {
    if (pending === identityKey()) return;
    if (identity !== identityKey() || Date.now() - lastLoaded >= TTL) refresh(true);
  }
  window.addEventListener('paintly:designs-loaded', function (e) {
    var d = e.detail;
    if (presenceSuspended || !d || !d.ownerId || d.ownerId !== owner() || d.creditCode !== credit() || !Array.isArray(d.designs)) return;
    ++revision; pending = ''; identity = identityKey();
    accept(snapshot(d.ownerId, d.creditCode, d.designs));
  });
  window.addEventListener('paintly:credit-change', syncIdentity);
  window.addEventListener('paintly:wishlist-scope-changed', function () { presenceSuspended = true; ++revision; pending = ''; lastLoaded = 0; S.n = 0; S.u = []; paint(); });
  window.addEventListener('storage', function (e) {
    if (e.key === null || e.key === 'ply_owner_id' || e.key === 'plyCreditCode') syncIdentity();
  });
  window.addEventListener('pageshow', syncIdentity);
  doc.addEventListener('visibilitychange', function () { if (!doc.hidden) syncIdentity(); });

  function start() {
    tool();
    identity = identityKey();
    var o = owner();
    if (!o) return;
    var c = readCache(o, credit());
    if (c) accept(c);
    else refresh(false);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
})();
